export default "__VITE_ASSET__DHPAWWDI__"